/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * "Yes, I'm interested": who to contact, and that they ticked the consent box.
 * 
 * The consent text itself is not sent: the server stores its own copy (`CONSENT_CHECKBOX_TEXT`).
 * @export
 * @interface HomeownershipInterestRequest
 */
export interface HomeownershipInterestRequest {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipInterestRequest
     */
    token: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipInterestRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipInterestRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipInterestRequest
     */
    phone?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeownershipInterestRequest
     */
    consentAccepted: boolean;
}

/**
 * Check if a given object implements the HomeownershipInterestRequest interface.
 */
export function instanceOfHomeownershipInterestRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "consentAccepted" in value;

    return isInstance;
}

export function HomeownershipInterestRequestFromJSON(json: any): HomeownershipInterestRequest {
    return HomeownershipInterestRequestFromJSONTyped(json, false);
}

export function HomeownershipInterestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipInterestRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': json['token'],
        'name': json['name'],
        'email': json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'consentAccepted': json['consent_accepted'],
    };
}

export function HomeownershipInterestRequestToJSON(value?: HomeownershipInterestRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
        'consent_accepted': value.consentAccepted,
    };
}

